import MainTimeline from './MainTimeline';

export default MainTimeline;
